<template>
  <validation-observer v-slot="{ handleSubmit }" ref="registrationObserver">
    <form @submit.prevent="handleSubmit(handleRegister)">
      <b-row cols="1">
        <b-col>
          <validation-provider
            v-slot="{ failed, errors }"
            rules="required|email"
            mode="eager"
            name="email"
          >
            <simple-form-input
              :hasError="failed"
              :helperText="errors[0]"
              :label="$t('general.email')"
              v-model="email"
              type="email"
            />
          </validation-provider>
        </b-col>
        <b-col>
          <validation-provider
            v-slot="{ failed, errors }"
            :rules="{
              required: true,
              min: 8,
              regex: PASSWORD_REGEX,
            }"
            name="password1"
            mode="eager"
          >
            <simple-form-input
              :hasError="failed"
              :helperText="errors[0]"
              :label="$t('general.password')"
              v-model="password1"
              type="password"
            />
          </validation-provider>
        </b-col>
        <b-col>
          <validation-provider
            rules="min:8|required|password:@password1"
            v-slot="{ errors, failed }"
            name="password2"
            mode="eager"
          >
            <simple-form-input
              type="password"
              v-model="password2"
              :label="$t('registrationForm.password2Label')"
              :hasError="failed"
              :helperText="errors[0]"
            />
          </validation-provider>
        </b-col>
        <b-col>
          <validation-provider
            :rules="{ required: { allowFalse: false } }"
            v-slot="{ errors }"
          >
            <b-form-checkbox
              required
              v-model="termsAgreed"
              :state="errors.length !== 0 ? false : null"
              class="register-checkbox"
            >
              {{ $t("registrationForm.IAgreeWith") }}
              <router-link to="/termsAndConditions" target="_blank">{{
                $t("registrationForm.TOC")
              }}</router-link>
              {{ $t("registrationForm.and") }}
              <router-link to="/privacyPolicy" target="_blank"
                >{{ $t("registrationForm.privacyPolicy") }}.</router-link
              >
            </b-form-checkbox>
          </validation-provider>
        </b-col>
      </b-row>
      <b-row cols="1">
        <b-col class="d-flex justify-content-center">
          <b-button
            type="submit"
            :disabled="isRegistering"
            id="registration-button"
          >
            <b-spinner small v-if="isRegistering" />
            <span> {{ $t("registrationForm.registerButton") }} </span>
          </b-button>
        </b-col>
        <b-col class="d-flex justify-content-center">
          <b-button variant="primary" :disabled="isRegistering" to="/">
            <span> {{ $t("general.logIn") }} </span>
          </b-button>
        </b-col>
        <b-col class="d-flex justify-content-center">
            <div class="google-btn-wrapper">
              <b-button
              variant="primary"
                :disabled="isRegistering"
                @click="loginWithGoogle"
                class="google-btn"
              >
                <img src="https://developers.google.com/identity/images/g-logo.png" width="18">
                Sign in with Google
              </b-button>
            </div>
          </b-col>
      </b-row>
    </form>
  </validation-observer>
</template>

<script>
import { PASSWORD_REGEX } from "../../utils/constants";
import SimpleFormInput from "../inputs/SimpleFormInput.vue";
import { mapActions } from "vuex";
import MainAlert from "../alerts/MainAlert.vue";
export default {
  components: { SimpleFormInput },
  name: "registration-form",
  data() {
    return {
      email: "",
      password1: "",
      password2: "",
      termsAgreed: false,
      isRegistering: false,
      PASSWORD_REGEX,
    };
  },
  mounted() {
    this.initializeGoogleSignIn();
  },
  methods: {
    ...mapActions(["register", "loginWithToken"]),
    handleRegister() {
      this.isRegistering = true;
      this.$gtag.event("sign_up");
      this.register({
        email: this.email,
        password1: this.password1,
        password2: this.password2,
      })
        .then(() => this.$emit("succeeded"))
        .catch((err) => {
          const errors = err.response.data;
          // Map non_field_errors to password1 field for display
          if (errors.non_field_errors && !errors.password1) {
            errors.password1 = errors.non_field_errors;
            delete errors.non_field_errors;
          }
          this.$refs.registrationObserver.setErrors(errors);
        })
        .finally(() => (this.isRegistering = false));
    },
    initializeGoogleSignIn() {
      // eslint-disable-next-line no-undef
      if (typeof google !== 'undefined' && google.accounts) {
        this.setupGoogleSignIn();
      } else {
        // Wait for google to load
        const checkGoogleLoaded = setInterval(() => {
          // eslint-disable-next-line no-undef
          if (typeof google !== 'undefined' && google.accounts) {
            clearInterval(checkGoogleLoaded);
            this.setupGoogleSignIn();
          }
        }, 100);
        
        // Timeout after 10 seconds
        setTimeout(() => {
          clearInterval(checkGoogleLoaded);
        }, 10000);
      }
    },
    setupGoogleSignIn() {
      // eslint-disable-next-line no-undef
      this.codeClient = google.accounts.oauth2.initTokenClient({
          client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
          scope: "openid email profile https://www.googleapis.com/auth/userinfo.email",
          ux_mode: "popup",
          callback: this.handleCredentialResponse
        });
    },
    loginWithGoogle() {
      this.codeClient.requestAccessToken();
    },
    handleCredentialResponse(response) {
      this.loginWithToken(response).catch(() => {
        if (this.loginError) {
          this.$toast.error({
            component: MainAlert,
            props: {
              message: this.loginError,
            },
          })
        } else {
          this.$toast.error({
            component: MainAlert,
            props: {
              message: this.$i18n.t("general.wrongCredentials"),
            },
          })
        }
      });
    }
  },
};
</script>


<style lang="scss" scoped>
.custom-checkbox.register-checkbox {
  a {
    margin: 0 3px;
    &:hover {
      text-decoration: underline;
    }
  }
}
.was-validated .custom-control-input:invalid ~ .custom-control-label,
.custom-control-input.is-invalid ~ .custom-control-label {
  a {
    color: #dc3545;
  }
}
.btn {
  width: toRem(250);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.btn-primary {
  margin-top: toRem(20);
}
.google-btn-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
</style>